// ConfDeck admin surface entry: fonts, core styles and the app root.
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/onest';
import '@fontsource-variable/golos-text';
import '@confdeck/core-web/styles.css';
import { AppRoot, attachTab, RecordLetters, registerRecordTabs, registerScreens, registerTypeEmpty } from '@confdeck/core-web';
import { companyTabs, conferenceScreens, ContactEvents, FirstConference, EventCertificate, ProjectSummary, eventSettingsTabs, EventLaunch, EventTeam, orderTabs, PcTemplatePreview, TalkPeople, ticketTabs } from '@confdeck/app-conferences/web';
import { knowledgeScreens } from '@confdeck/app-knowledge/web';
import { setupCrmWeb } from '@confdeck/app-crm/web';

registerScreens(conferenceScreens);
registerScreens(knowledgeScreens);
// Deals live in pipelines: the second menu lists them under «Сделки», a chosen one narrows every view (um/2026-10-29/01 п.11).
setupCrmWeb();
registerRecordTabs('order', orderTabs);
registerRecordTabs('pc_template', [{ key: 'preview', label: 'Просмотр', component: PcTemplatePreview }]);
// J7: a material's file is uploaded in its card; participants get it in the personal page by the event's rule.
registerRecordTabs('material', [{ key: 'file', label: 'Файл', component: attachTab('url', 'Файл материала: презентация, раздаточный материал. Запись доклада — ссылкой YouTube, VK или Rutube в поле «Ссылка или файл», она встроится плеером.') }]);
registerRecordTabs('event', [{ key: 'launch', label: 'Запуск', component: EventLaunch }, ...eventSettingsTabs, { key: 'team', label: 'Команда', component: EventTeam }, { key: 'certificate', label: 'Сертификат', component: EventCertificate }]);
registerTypeEmpty('conference', FirstConference);
// R-E8: the numbers of a project over its events, above its tabs; a contact's history by the events of each project.
registerRecordTabs('conference', [{ key: 'summary', label: 'Сводка', component: ProjectSummary, head: true }]);
registerRecordTabs('contact', [{ key: 'events', label: 'События', component: ContactEvents }]);
registerRecordTabs('talk', [{ key: 'people', label: 'Люди', component: TalkPeople }]);
registerRecordTabs('ticket', ticketTabs);
registerRecordTabs('company', companyTabs);

// R-M6: the chains of letters about a contact, a company, a deal.
for (const t of ['contact', 'company', 'deal']) registerRecordTabs(t, [{ key: 'mail', label: 'Письма', component: RecordLetters }]);

createRoot(document.getElementById('root')!).render(<AppRoot />);
